import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';

import clearModal from '@shoflo/studio-redux/actions/modal/clearModal/clearModal';
import createBanner from 'actions/Broadcast/banners/createBanner';
import updateBanner from 'actions/Broadcast/banners/updateBanner';
import getGlobalBannerTemplates from 'actions/Broadcast/banners/getGlobalBannerTemplates';

import ModalHeader from 'components/Modal/Header';
import { BANNER_FORM } from 'constants/ModalTypes';
import BannerLayerSourceForm from 'components/BannerLayerSourceForm/BannerLayerSourceForm';

const BannerForm = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGlobalBannerTemplates());
  }, [dispatch]);

  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === BANNER_FORM
  );
  const banner = useSelector(({ modal }) => modal && modal.initialValue);
  const isEditMode = banner ? true : false;

  const templates = useSelector(({ bannerTemplates }) => bannerTemplates);

  const clearThisModal = () => dispatch(clearModal(BANNER_FORM));

  if (!isOpen) return null;

  const handleSubmit = layerSource => {
    //NOTE: createBanner accepts just the source values for now. However it is anticipated that in the near future the BannerLayerSourceForm
    //will also provide a means to submit layer style / position. For now we'll deconstruct and only pass the source from this form.
    const { source } = layerSource;

    if (isEditMode) {
      dispatch(updateBanner(banner._id, layerSource));
    } else {
      dispatch(createBanner(source));
    }

    dispatch(clearModal(BANNER_FORM));
  };

  return (
    <Modal
      size="xl"
      isOpen={isOpen && templates.length > 0}
      toggle={clearThisModal}
    >
      <ModalHeader>{isEditMode ? 'Edit' : 'Create'} banner</ModalHeader>
      <ModalBody>
        <BannerLayerSourceForm
          banner={banner}
          templates={templates}
          onSubmit={handleSubmit}
          onCancel={clearThisModal}
        />
      </ModalBody>
    </Modal>
  );
};

export default BannerForm;
